import { useEffect, useState } from 'react';
import { DL_QUERY_STRINGS } from '../../../constants/dealerLocator.constants';
import { windowService } from '../../../utils/window.utils.js';

const useSearchText = (defaultValue): [string, React.Dispatch<React.SetStateAction<string>>] => {
  const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
  const query = getQuery(DL_QUERY_STRINGS.SEARCH_QUERY);
  const [queryText, setQueryText] = useState<string>(query || defaultValue);
  const [urlQueryText, setUrlQueryText] = useState<string>(queryText);

  useEffect(() => {
    if (!query || query === urlQueryText) {
      return;
    }

    setQueryText(query);
  }, [query, urlQueryText]);

  useEffect(() => {
    setUrlQueryText(query ?? '');
  }, [query]);

  return [queryText, setQueryText];
};

export default useSearchText;
